var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"read-status"},[_c('md-icon',{staticClass:"icon-check",attrs:{"md-src":"/static/images/icon-check.svg"}}),_vm._v(" "),_c('span',{staticClass:"read-text"},[_vm._v("Lido: "+_vm._s(_setup.formattedDate))])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }